import { useClientPortalConfigContext } from "../../../../context/ClientPortalConfig.ctx";
import { usePostMutation } from "../../../../hooks/useClientPortalQuery";
import { CalculateStripeSurchargeModel, StripeSurcharge } from "../../../../types/generated/models";
import { AxiosError } from "axios";

export function useCalculateStripeSurcharge() {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const { mutateAsync, isPending } = usePostMutation<StripeSurcharge, AxiosError, CalculateStripeSurchargeModel>({
        url: `/api/v1/${clientPortalGuid}/Stripe/CalculateStripeSurcharge`,
    });

    return {
        calculateStripeSurcharge: mutateAsync,
        isLoading: isPending,
    };
}
